module.exports = __webpack_public_path__ + "res/Roboto-Black-webfont.ttf?bfe0d04e9c1287226c36265f47147623";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Black-webfont.ttf
// module id = 84
// module chunks = 0